import {
  chromeYellow,
  kiwiGreen, sanguine, ultraMarine,
} from '@cogneed/react-utils';
import CloseIcon from '@mui/icons-material/CloseRounded';
import { Button, Fade, styled } from '@mui/material';
import { MaterialDesignContent, SnackbarProvider, closeSnackbar } from 'notistack';
import React from 'react';

const StyledMaterialDesignContent = styled(MaterialDesignContent)(({ theme }) => ({
  '&.notistack-MuiContent': {
    width: '100%',
    boxShadow: theme.shadows[2],
    display: 'flex',
    flexWrap: 'nowrap',
    '& .MuiButton-root': {
      padding: 4,
      minWidth: 0,
      width: 32,
      height: 32,
      color: 'inherit',
      '& svg': {
        fontSize: 16,
        color: 'inherit',
      },
    },
  },
  '&.notistack-MuiContent-error': {
    backgroundColor: sanguine[100],
    color: sanguine[600],
  },
  '&.notistack-MuiContent-success': {
    backgroundColor: kiwiGreen[100],
    color: kiwiGreen[600],
  },
  '&.notistack-MuiContent-info': {
    backgroundColor: ultraMarine[100],
    color: ultraMarine[400],
  },

  '&.notistack-MuiContent-warning': {
    backgroundColor: chromeYellow[500],
    color: chromeYellow[100],
  },
}));

function renderAction(snackbarId: string) {
  return (
    <Button onClick={() => closeSnackbar(snackbarId)}>
      <CloseIcon />
    </Button>
  );
}

export default function StyledSnackbarProvider(props: { children: React.ReactNode, domRoot?: HTMLDivElement }) {
  const { children, domRoot } = props;
  return (
    <SnackbarProvider
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      dense
      classes={{
        containerRoot: 'SnackbarContainer-root',
      }}
      domRoot={domRoot}
      autoHideDuration={5000}
      maxSnack={3}
      TransitionComponent={Fade}
      transitionDuration={600}
      disableWindowBlurListener
      Components={{
        success: StyledMaterialDesignContent,
        info: StyledMaterialDesignContent,
        error: StyledMaterialDesignContent,
        warning: StyledMaterialDesignContent,
      }}
      action={renderAction}
    >
      {children}
    </SnackbarProvider>
  );
}
